import { tenantLogsTypes } from "../types";
import { defaultPanasonicTenantDetails } from "../../utils/deafultTenant";
const initialState = {
    tenantLogs: [],
    tenantLogsLoading: false,
    tenantLogsError: false,
    tenantLogsErrorMessage: "",
};

export function tenantLogsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case tenantLogsTypes.GET_TENANT_LOGS_REQUEST:
            return {
                ...state,
                tenantLogs: [],
                tenantLogsLoading: true,
                tenantLogsError: false,
                tenantLogsErrorMessage: "",
            };
        case tenantLogsTypes.GET_TENANT_LOGS_SUCCESS:
            return {
                ...state,
                tenantLogs: payload,
                tenantLogsLoading: false,
                tenantLogsError: false,
                tenantLogsErrorMessage: "",
            };
        case tenantLogsTypes.GET_TENANT_LOGS_FAILURE:
            return {
                ...state,
                tenantLogs: [],
                tenantLogsLoading: false,
                tenantLogsError: true,
                tenantLogsErrorMessage: payload?.error || "",
            }
        default:
            return state;
    }
}
